import React from "react";
import { getLastseen } from "../WebChatTimeStamp";
import SDK from "../../../SDK";
import { useSelector } from "react-redux";
import { USER_PRESENCE_STATUS_OFFLINE, USER_PRESENCE_STATUS_ONLINE } from "../../../Helpers/Chat/Constant";
import { formatUserIdToJid } from "../../../Helpers/Chat/User";

const LastSeen = (props) =>{
  const [lastSeenData , setLastSeenData] = React.useState({
    seconds: -1,
    lastSeen: "",
    userPresenceStatus: ""
  })
  let timer = 0;
  const { jid } = props;

  const  presenseData  = useSelector(store => store?.presenseData)
  const  blockedContact  = useSelector(store => store?.blockedContact)
  const  contactsWhoBlockedMe  = useSelector(store => store?.contactsWhoBlockedMe)
  const { data } = presenseData
  const {fromUserJid, status} = data;
  const userJid = props.jid;
  const appOnlineStatus = useSelector(store => store?.appOnlineStatus)
  // const adminBlock = useSelector(store => store?.appOnlineStatus)
  const { isAppOnline } = appOnlineStatus
  
  React.useEffect(()=>{
      if (jid) {
        updateLastSeen(jid);
      }
      return () => (clearTimeout(timer));
  },[])
  
  React.useEffect(()=>{
    updateLastSeen(userJid);
  },[props.jid])

  React.useEffect(()=>{
    updateLastSeen(userJid);
  },[contactsWhoBlockedMe?.id, blockedContact?.id])

  React.useEffect(()=>{
    if(fromUserJid === userJid && status !== lastSeenData.userPresenceStatus){
      if(status === USER_PRESENCE_STATUS_OFFLINE){
        timer = setTimeout(async () => {
          updateLastSeen(userJid, status);
        }, 500);
    }
    else{
      updateLastSeen(userJid, status);
    }
  }
  },[presenseData])

  React.useEffect(()=>{
    if(!isAppOnline && lastSeenData.userPresenceStatus === USER_PRESENCE_STATUS_ONLINE){
      updateLastSeen(userJid, undefined, 1);
    }
    if(isAppOnline && lastSeenData.userPresenceStatus === USER_PRESENCE_STATUS_OFFLINE){
      setTimeout(async () => {
          updateLastSeen(userJid);
        },3000);
    }
  },[isAppOnline])

  const isUserBlocked = (userJid) => {
    let blockedContacts = blockedContact.data;
    let contactsWhoBlockedMes = contactsWhoBlockedMe.data;
    return blockedContacts.indexOf(userJid) > -1 || contactsWhoBlockedMes.indexOf(userJid) > -1;
  }

  const getLastSeenSeconds = async (user_Jid) => {
    if(!user_Jid) return -1;
    /**
    // user_Jid = formatUserIdToJid(user_Jid);
    */
    const lastSeenRes = await SDK.getLastSeen(user_Jid);
    if(lastSeenRes && lastSeenRes.statusCode === 200){
      /**
      // store.dispatch(LastActivityDataAction(lastSeenRes.data));
      */
      return lastSeenRes?.data?.seconds;
    }
    return -1;
  }

  const updateLastSeen = async ( updateUserJid, userPresenceStatus, lastSeenSeconds) => {
    if(!updateUserJid) return;
    updateUserJid = formatUserIdToJid(updateUserJid);
    let seconds = "";
    let lastSeen = '';
    if(!isUserBlocked(updateUserJid)){
      seconds = lastSeenSeconds || await getLastSeenSeconds(updateUserJid);
      lastSeen = (seconds != -1) ? getLastseen(seconds) : '';
    }
    userPresenceStatus = userPresenceStatus || (seconds > 0 ? USER_PRESENCE_STATUS_OFFLINE : USER_PRESENCE_STATUS_ONLINE);
    setLastSeenData({
      ...lastSeenData,
      seconds, lastSeen, userPresenceStatus});
  }
  return <h6>{lastSeenData.lastSeen}</h6>;
}

export default LastSeen